import { GetCmSheetAvailableCoursesResponse } from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CmSheetAvailableCoursesService = {
  async list(
    cmSheetId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCmSheetAvailableCoursesResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetCmSheetAvailableCoursesResponse>(
      `v1/cm-sheets/${cmSheetId}/available-courses?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
};

export default CmSheetAvailableCoursesService;
